import { ReportPharmaPlanComponent } from '@shared/report-pharma-plan/report-pharma-plan.component';
import { ReportMedChangesReComponent } from '@shared/report-med-changes-re/report-med-changes-re.component';
import { ReportDebtsReComponent } from '@shared/report-debts-re/report-debts-re.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InstitutionEditComponent } from '@shared/institution-edit/institution-edit.component';
import { ReportPMedicineUseComponent } from '@shared/report-p-medicine-use/report-p-medicine-use.component';

import { authGuard, authGuardOwnUser, authGuardRol } from '@guards/auth.guard';

import { ForgotPasswordComponent } from '@shared/forgot-password/forgot-password.component';
import { LoginComponent } from '@shared/login/login.component';
import { SelectInstitutionComponent } from '@shared/select-institution/select-institution.component';
import { WelcomeComponent } from '@shared/welcome/welcome.component';
import { LayoutFarmaComponent } from './components/layout-farma/layout-farma.component';
import { CardsComponent as PatientCardsComponent } from './components/patients-farma/cards/cards.component';
import { ListsComponent as PatientListsComponent } from './components/patients-farma/lists/lists.component';
import { PatientsFarmaComponent } from './components/patients-farma/patients-farma.component';

import { CardsComponent as MedicineCardsComponent } from './components/medicines-farma/cards/cards.component';
import { ListsComponent as MedicineListsComponent } from './components/medicines-farma/lists/lists.component';

import { MedicineEditComponent } from '@shared/medicine-edit/medicine-edit.component';
import { NotFoundComponent } from '@shared/not-found/not-found.component';
import { PatientEditComponent } from '@shared/patient-edit/patient-edit.component';
import { ResetPasswordComponent } from '@shared/reset-password/reset-password.component';

import { MedicineNewComponent } from '@shared/medicine-new/medicine-new.component';
import { ReportAuthBlistersComponent } from '@shared/report-auth-blisters/report-auth-blisters.component';
import { CardsComponent as InstitutionCardsComponent } from './components/institutions-farma/cards/cards.component';
import { InstitutionsFarmaComponent } from './components/institutions-farma/institutions-farma.component';
import { ListsComponent as InstitutionListsComponent } from './components/institutions-farma/lists/lists.component';
import { MedicinesFarmaComponent } from './components/medicines-farma/medicines-farma.component';
import { ReportViewerComponent } from '@shared/report-viewer/report-viewer.component';
import { ReportPMovementsComponent } from '@shared/report-p-movements/report-p-movements.component';
import { ReportListPatientsComponent } from '@shared/report-list-patients/report-list-patients.component';
import { ReportMedicinesMissingComponent } from '@shared/report-medicines-missing/report-medicines-missing.component';
import { ReportPDietComponent } from '@shared/report-p-diet/report-p-diet.component';
import { ReportPescriptionsPEvalComponent } from '@shared/report-pescriptions-p-eval/report-pescriptions-p-eval.component';
import { ReportClinicComponent } from '@shared/report-clinic/report-clinic.component';
import { ReportMedicamentNoEmblisComponent } from '@shared/report-medicament-no-emblis/report-medicament-no-emblis.component';
import { ReportPolimedicationComponent } from '@shared/report-polimedication/report-polimedication.component';
import { ReportIefComponent } from '@shared/report-ief/report-ief.component';
import { ReportIncontinenceComponent } from '@shared/report-incontinence/report-incontinence.component';
import { ReportScpComponent } from '@shared/report-scp/report-scp.component';
import { ReportDebsOrdersComponent } from '@shared/report-debs-orders/report-debs-orders.component';
import { ReportElectronicRecipeComponent } from '@shared/report-electronic-recipe/report-electronic-recipe.component';
import { ReportChangeMedicationsPharmaComponent } from '@shared/report-change-medications-pharma/report-change-medications-pharma.component';
import { ReportPatientIssuesComponent } from '@shared/report-patient-issues/report-patient-issues.component';
import { ProcReceptionsComponent } from '@shared/proc-receptions/proc-receptions.component';
import { ProcPlansComponent } from '@shared/proc-plans/proc-plans.component';
import { ReStatusComponent } from '@shared/re-status/re-status.component';
import { ReportBillingComponent } from '@shared/report-billing/report-billing.component';
import { ReportSevereComponent } from '@shared/report-severe/report-severe.component';
import { ProcAuthorizationCancelationComponent } from '@shared/proc-authorization-cancelation/proc-authorization-cancelation.component';
import { ReportPatientBoxesComponent } from '@shared/report-patient-boxes/report-patient-boxes.component';
import { ReportObsolescenceMedsComponent } from '@shared/report-obsolescence-meds/report-obsolescence-meds.component';
import { ReportMECComponent } from '@shared/report-mec/report-mec.component';
import { ReportPolymedicationFarmaComponent } from '@shared/report-polymedication-farma/report-polymedication-farma.component';
import { ReportInstitutionMedComponent } from '@shared/report-institution-med/report-institution-med.component';
import { ReportAnnexComponent } from '@shared/report-annex/report-annex.component';
import { ReportAutomaticResetComponent } from '@shared/report-automatic-reset/report-automatic-reset.component';
import { ReportThirdPartiesComponent } from '@shared/report-third-parties/report-third-parties.component';
import { ReportForecastComponent } from '@shared/report-forecast/report-forecast.component';
import { VentasFarmaticComponent } from '@shared/ventas-farmatic/ventas-farmatic.component';
import { VersionChangedComponent } from '@shared/version-changed/version-changed.component';
import { MaintenanceComponent } from '@shared/maintenance/maintenance.component';
import { Permission, PermissionType } from '@json/src/app/enums/PermissionType';
import { AdminComponent } from '@shared/admin/admin.component';
import { UserComponent as AdminUserComponent } from '@shared/admin/user/user.component';
import { UsersComponent as AdminUsersComponent } from '@shared/admin/users/users.component';
import { CardsComponent as AdminUsersCardsComponent } from '@shared/admin/users/cards/cards.component';
import { ListsComponent as AdminUserListsComponent } from '@shared/admin/users/lists/lists.component';
import { ReportNarcoticsMedicinesComponent } from '@shared/report-narcotics-medicines/report-narcotics-medicines.component';
import { UsavedChangesGuard as UnsavedChangesGuard } from '@guards/unsaved-changes.guard';
import { ReportMedicationPlanComponent } from '@shared/report-medication-plan/report-medication-plan.component';
import { ReportFGPPrescriptionsComponent } from '@shared/report-fgp-prescriptions/report-fgp-prescriptions.component';
import { ReportMedicinesDangerousComponent } from '@shared/report-medicines-dangerous/report-medicines-dangerous.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'version', component: VersionChangedComponent },
  { path: 'maintenance', component: MaintenanceComponent },
//   { path: 'forgot-password', component: ForgotPasswordComponent },
//   { path: 'reset-password/:token', component: ResetPasswordComponent },
  {
    path: 'select-institution',
    component: SelectInstitutionComponent,
    canActivate: [authGuard],
  },
  {
    path: 'global-eye',
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    component: LayoutFarmaComponent,
    children: [
      { path: '', redirectTo: 'welcome', pathMatch: 'full' },
      { path: 'welcome', component: WelcomeComponent },
      {
        path: 'patients',
        component: PatientsFarmaComponent,
        canActivate: [authGuardRol(Permission.PATIENTS)],
        children: [
          { path: '', redirectTo: 'cards', pathMatch: 'full' },
          { path: 'cards', component: PatientCardsComponent },
          { path: 'list', component: PatientListsComponent },
          { path: 'edit', component: PatientEditComponent },
          { path: 'edit/:id', component: PatientEditComponent, canDeactivate: [UnsavedChangesGuard] },
        ],
      },
      {
        path: 'institutions',
        component: InstitutionsFarmaComponent,
        canActivate: [authGuardRol(Permission.INSTITUTIONS)],
        children: [
          { path: '', redirectTo: 'cards', pathMatch: 'full' },
          { path: 'cards', component: InstitutionCardsComponent },
          { path: 'list', component: InstitutionListsComponent },
          { path: 'edit', component: InstitutionEditComponent },
          { path: 'edit/:id', component: InstitutionEditComponent, canDeactivate: [UnsavedChangesGuard] },
        ],
      },
      {
        path: 'medicines',
        component: MedicinesFarmaComponent,
        canActivate: [authGuardRol(Permission.VADEMECUM)],
        children: [
          { path: '', redirectTo: 'cards', pathMatch: 'full' },
          { path: 'cards', component: MedicineCardsComponent },
          { path: 'list', component: MedicineListsComponent },
          { path: 'edit', component: MedicineNewComponent, canDeactivate: [UnsavedChangesGuard] },
          { path: 'edit/:id', component: MedicineEditComponent, canDeactivate: [UnsavedChangesGuard] },
        ],
      },
      {
        path: 'procs',
        canActivate: [authGuardRol(Permission.PROCS_MENU)],
        children: [
          { path: '', redirectTo: 'plans', pathMatch: 'full' },
          // { path: 'receptions', component: ProcReceptionsComponent }, // corota = hefame
          { path: 'plans', component: ProcPlansComponent, canActivate: [authGuardRol(Permission.PROCS_PLANS)] }, // corota = dp
          { path: 're-status', component: ReStatusComponent, canActivate: [authGuardRol(Permission.PROCS_RE)]  }, // corota = restat
          { path: 'in-out-re', component: ProcAuthorizationCancelationComponent, canActivate: [authGuardRol(Permission.PROCS_ALTAS)]  }, // corota = dailychgs
          { path: 'ventas-farmatic', component: VentasFarmaticComponent, canActivate: [authGuardRol(Permission.PROCS_VENTAS)] }
        ],
      },
      {
        path: 'reports',
        canActivate: [authGuardRol(Permission.REPORTS)],
        children: [
          { path: '', redirectTo: 'autorblis', pathMatch: 'full' },
          { path: 'viewer', component: ReportViewerComponent },
          { path: 'billing', component: ReportBillingComponent }, //corota=invoicing
          { path: 'forecast', component: ReportForecastComponent }, //corota=forecast
          { path: 'logs', component: ReportThirdPartiesComponent }, //corota=tp/log
          { path: 'patboxes', component: ReportPatientBoxesComponent }, //corota=patboxes
          { path: 'obsomeds', component: ReportObsolescenceMedsComponent }, //corota= obsomeds
          { path: 'mec', component: ReportMECComponent }, //corota=invoicing
          {
            path: 'polymedication',
            component: ReportPolymedicationFarmaComponent,
          }, //corota=polymed
          { path: 'instmed', component: ReportInstitutionMedComponent }, //instmed
          { path: 'severes', component: ReportSevereComponent }, //corota=agudos
          { path: 'ra', component: ReportAutomaticResetComponent }, //corota=ra
          { path: 'autorblis', component: ReportAuthBlistersComponent },
          { path: 'pathmeds', component: ReportPMedicineUseComponent },
          { path: 'patientlist', component: ReportListPatientsComponent },
          { path: 'patchgs', component: ReportPMovementsComponent },
          { path: 'patissues', component: ReportPatientIssuesComponent },
          { path: 'pharmaplan', component: ReportPharmaPlanComponent },
          { path: 'patdiet', component: ReportPDietComponent },
          { path: 'mednostock', component: ReportMedicinesMissingComponent },
          { path: 'meddangerous', component: ReportMedicinesDangerousComponent },
          { path: 'nelist', component: ReportMedicamentNoEmblisComponent },
          { path: 'prescrpe', component: ReportPescriptionsPEvalComponent },
          { path: 'cursocl', component: ReportClinicComponent },
          { path: 'medchanges', component: ReportChangeMedicationsPharmaComponent },
          { path: 'medchangesre', component: ReportMedChangesReComponent },
          { path: 'debtsre', component: ReportDebtsReComponent },
          { path: 'medidebt', component: ReportDebsOrdersComponent },
          { path: 'restat', component: ReportElectronicRecipeComponent },
          { path: 'ief', component: ReportIefComponent },
          { path: 'diapers', component: ReportIncontinenceComponent },
          { path: 'polymed', component: ReportPolimedicationComponent },
          { path: 'pharmalert', component: ReportScpComponent },
          { path: 'annex', component: ReportAnnexComponent },
          { path: 'estupef', component: ReportNarcoticsMedicinesComponent }, //corota=estupef
          { path: 'pmoperations', component: ReportMedicationPlanComponent },
          { path: 'fgpprescriptions', component: ReportFGPPrescriptionsComponent },
        ],
      },
      {
        path: 'admin',
        component: AdminComponent,
        children: [
          { path: '', redirectTo: 'users', pathMatch: 'full' },
          { 
            path: 'users', 
            component: AdminUsersComponent, 
            children: [
              { path: '', redirectTo: 'cards', pathMatch: 'full' },
              { path: 'cards', component: AdminUsersCardsComponent, canActivate: [authGuardRol(Permission.USERS, PermissionType.READ)] },
              { path: 'list', component: AdminUserListsComponent, canActivate: [authGuardRol(Permission.USERS, PermissionType.READ)] },
              { path: 'new', component: AdminUserComponent, canActivate: [authGuardRol(Permission.USERS, PermissionType.WRITE)] },
              { path: 'edit/:id', component: AdminUserComponent, canActivate: [authGuardOwnUser], data: {permissions: [Permission.USERS], permissionType: PermissionType.WRITE} },
            ] 
          },
        ]
      }
    ],
  },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
